/* unplugin-vue-components disabled */import { render } from "./huafei.vue?vue&type=template&id=254eece3&scoped=true"
import script from "./huafei.vue?vue&type=script&lang=js"
export * from "./huafei.vue?vue&type=script&lang=js"

import "./huafei.vue?vue&type=style&index=0&id=254eece3&lang=less&scoped=true"

import exportComponent from "/home/nightdays/app/code/vue/nb-recharge/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254eece3"]])

export default __exports__